import { FilterCustomer, FindCustomerModal } from "@/components/organisms";
import { useCallback, useEffect, useState } from "react";
import { useCustomer, useFilter, useModal } from "@/hooks";
import { GetListParams } from "@/api/customer/interface";
import { Messaging } from "@/components/pages/Messaging";
import { useApi } from "@/api";

const MessagingView = () => {
    const {customer, settings } = useApi();
      const {
    filter,
    numberOfFilters,
    setShouldFilter,
    shouldFilter,
    ...filterProps
  } = useFilter<FilterCustomer>();
  const { selectedCustomer, setSelectedCustomer } = useCustomer();
    const [loadingCustomers, setLoadingCustomers] = useState(false);
  const { showModal, onCloseModal, onOpenModal } = useModal();
  const currentPage = 1;

  const getCustomers = async (data?: GetListParams) => {
    setLoadingCustomers(true);
    await customer.getList(data);
    setLoadingCustomers(false);
  }

    useEffect(() => {
    setSelectedCustomer(null);
  }, []);

  

  useEffect(() => {
    if (shouldFilter) {
      if (filter) {
        getCustomers({
          accountName: filter.login,
          address: filter.location,
          code: filter.customerCode,
          email: filter.customerEmail,
          isActive: filter.active,
          name: filter.companyName,
          page: currentPage
        });
      } else {
        getCustomers();
      }
      setShouldFilter(false);
    }
  }, [filter, shouldFilter]);

    const handleFindCustomerModal = useCallback(() => {
    if (customer.customers.length === 0) {
      getCustomers();
    }
    onOpenModal();
  }, [customer.customers]);

  const handleSelectCustomer = useCallback((customerId: string) => {
    const selected = customer.customers.find((item) => item.id === customerId);
    
    if (selected) {
      setSelectedCustomer(selected);
    }
  }, [customer.customers]);

  const handleRemoveCustomer = useCallback(() => {
    setSelectedCustomer(null);
  }, []);

  const handleSendMessage = useCallback(async (phoneNumber: string, message: string) => {
    await settings.sendWhatsappMessage(phoneNumber, message)
    }, []);

    const getTemplates = async () => {
        await settings.listTemplates();
    }

    const getWhatsappTemplates = async () => {
        await settings.listWhatsappTemplates();
    }

    useEffect(() => {
        getTemplates();
        getWhatsappTemplates();
    }, []);

    
  
  return (
    <>
    <Messaging
      onAddSmsTemplate={settings.addTemplate}
      onEditSmsTemplate={settings.editTemplate}
      onDeleteSmsTemplate={settings.deleteTemplate}
      onReloadSmsTemplates={getTemplates}
      onAddWhatsappTemplate={settings.addWhatsappTemplate}
      onEditWhatsappTemplate={settings.editWhatsappTemplate}
      onDeleteWhatsappTemplate={settings.deleteWhatsappTemplate}
      onReloadWhatsappTemplates={getWhatsappTemplates}
      onFindCustomer={handleFindCustomerModal}
      onRemoveCustomer={handleRemoveCustomer}
      onSendWhatsappMessage={handleSendMessage}
      selectedCustomer={selectedCustomer}
      smsTemplates={settings.smsTemplates}
      whatsappTemplates={settings.whatsappTemplates}
    />
          {showModal && (
            <FindCustomerModal
              customers={customer.customers}
              loading={loadingCustomers}
              onClose={onCloseModal}
              onSelectCustomer={handleSelectCustomer}
              {...filterProps}
              filter={filter}
              numberOfFilters={numberOfFilters}
            />
          )}
    </>
  );
}

export default MessagingView;